/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: fRuRbcdHVNMtdcnFK96ivt
// Component: rUOYhIsDnGOJ
import * as React from "react";
import {
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  useCurrentUser
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import * as plasmicAuth from "@plasmicapp/react-web/lib/auth";
import { usePlasmicDataSourceContext } from "@plasmicapp/data-sources-context";
import AppShell from "../../AppShell"; // plasmic-import: Vh273IDurq9t/component
import WebTab from "../../WebTab"; // plasmic-import: XNSjqwwbHvXu/component
import WebTopNav from "../../WebTopNav"; // plasmic-import: tGgk6oqzsXGR/component
import Breadcrumb from "../../Breadcrumb"; // plasmic-import: k0sjE64BjPfV/component
import ButtonSecondary from "../../ButtonSecondary"; // plasmic-import: yzRkzInaRral/component
import TabInTab from "../../TabInTab"; // plasmic-import: PX6_ceQKCHMf/component
import WebTabSideNav from "../../WebTabSideNav"; // plasmic-import: 0WZFGqgrkZcg/component
import ButtonTab from "../../ButtonTab"; // plasmic-import: vKI2fFYew03y/component
import SeparatorVertical from "../../SeparatorVertical"; // plasmic-import: gHGPazbS0-f7/component
import WidgetPeopleWall from "../../WidgetPeopleWall"; // plasmic-import: zYoTgxRpN7IY/component
import WebDock from "../../WebDock"; // plasmic-import: EtVLWfl2KEmA/component
import ButtonDock from "../../ButtonDock"; // plasmic-import: utQE8oqBBjiK/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/projectcss
import sty from "./PlasmicWebPartnersCommunity.module.css"; // plasmic-import: rUOYhIsDnGOJ/css
import Icon26Icon from "./icons/PlasmicIcon__Icon26"; // plasmic-import: flPWDcL8BgpD/icon
import Icon21Icon from "./icons/PlasmicIcon__Icon21"; // plasmic-import: RGhsUfKJWqUS/icon
import Icon16Icon from "./icons/PlasmicIcon__Icon16"; // plasmic-import: tHgx1odAov4w/icon
import Icon30Icon from "./icons/PlasmicIcon__Icon30"; // plasmic-import: v-1PLPXOc6tO/icon
import Icon23Icon from "./icons/PlasmicIcon__Icon23"; // plasmic-import: YwlgzG5yARIP/icon
import Icon34Icon from "./icons/PlasmicIcon__Icon34"; // plasmic-import: 3VA-qZnm8pUB/icon
import Icon32Icon from "./icons/PlasmicIcon__Icon32"; // plasmic-import: dWHMt3F1tCmW/icon
import Icon33Icon from "./icons/PlasmicIcon__Icon33"; // plasmic-import: h408FMoSv0qx/icon
import Icon15Icon from "./icons/PlasmicIcon__Icon15"; // plasmic-import: KZeS8_m5UsgE/icon
import Icon27Icon from "./icons/PlasmicIcon__Icon27"; // plasmic-import: WzMsUn33Iqfb/icon

const emptyProxy = new Proxy(() => "", {
  get(_, prop) {
    return prop === Symbol.toPrimitive ? () => "" : emptyProxy;
  }
});

function wrapQueriesWithLoadingProxy($q) {
  return new Proxy($q, {
    get(target, queryName) {
      const query = target[queryName];
      return !query || query.isLoading || !query.data ? emptyProxy : query;
    }
  });
}

export function generateDynamicMetadata($q, $ctx) {
  return {
    title: "o21p partners community.",
    openGraph: {
      title: "o21p partners community."
    },
    twitter: {
      card: "summary",
      title: "o21p partners community."
    }
  };
}

createPlasmicElementProxy;

export const PlasmicWebPartnersCommunity__VariantProps = new Array();

export const PlasmicWebPartnersCommunity__ArgProps = new Array();

const $$ = {};

function PlasmicWebPartnersCommunity__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  const styleTokensClassNames = _useStyleTokens();
  return (
    <React.Fragment>
      <div
        data-plasmic-name={"root"}
        data-plasmic-override={overrides.root}
        data-plasmic-root={true}
        data-plasmic-for-node={forNode}
        className={classNames(
          projectcss.all,
          projectcss.root_reset,
          projectcss.plasmic_default_styles,
          projectcss.plasmic_mixins,
          styleTokensClassNames,
          sty.root
        )}
      >
        <AppShell
          data-plasmic-name={"appShell"}
          data-plasmic-override={overrides.appShell}
          appShell={
            <WebTab
              data-plasmic-name={"webTab"}
              data-plasmic-override={overrides.webTab}
              bgColor={"secondary"}
              className={classNames("__wab_instance", sty.webTab)}
              tabContent={
                <TabInTab
                  data-plasmic-name={"tabInTab"}
                  data-plasmic-override={overrides.tabInTab}
                  className={classNames("__wab_instance", sty.tabInTab)}
                  tabContent={
                    <div
                      className={classNames(projectcss.all, sty.freeBox__yJv3Q)}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          sty.freeBox___3R4Dz
                        )}
                      >
                        <div
                          className={classNames(
                            projectcss.all,
                            sty.freeBox__gvSt
                          )}
                        >
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__snXg
                            )}
                          >
                            <h1
                              data-plasmic-name={"h1"}
                              data-plasmic-override={overrides.h1}
                              className={classNames(
                                projectcss.all,
                                projectcss.h1,
                                projectcss.h1__fRuRb,
                                projectcss.__wab_text,
                                sty.h1
                              )}
                            >
                              {
                                "the people shaping the future of independent practice."
                              }
                            </h1>
                            <div
                              data-plasmic-name={"text"}
                              data-plasmic-override={overrides.text}
                              className={classNames(
                                projectcss.all,
                                projectcss.__wab_text,
                                sty.text
                              )}
                            >
                              <React.Fragment>
                                <React.Fragment>
                                  {
                                    "Our mission is to empower the independent to navigate 21st-century\u2019s digital world without sacrificing autonomy or compromising who they are.\n\n"
                                  }
                                </React.Fragment>
                                <span
                                  className={
                                    "plasmic_default__all plasmic_default__span plasmic_default__span__fRuRb"
                                  }
                                  style={{ color: "var(--token-uJHxyuS0GRKH)" }}
                                >
                                  {
                                    "Designing and building the infrastructure is how we start."
                                  }
                                </span>
                              </React.Fragment>
                            </div>
                          </div>
                        </div>
                      </div>
                      <SeparatorVertical
                        data-plasmic-name={"separatorVertical"}
                        data-plasmic-override={overrides.separatorVertical}
                        className={classNames(
                          "__wab_instance",
                          sty.separatorVertical
                        )}
                        color={"uiSeparator"}
                        width={"s"}
                      />

                      <WidgetPeopleWall
                        data-plasmic-name={"widgetPeopleWall"}
                        data-plasmic-override={overrides.widgetPeopleWall}
                        className={classNames(
                          "__wab_instance",
                          sty.widgetPeopleWall
                        )}
                      />
                    </div>
                  }
                  tabNav={
                    <WebTabSideNav
                      data-plasmic-name={"webTabSideNav"}
                      data-plasmic-override={overrides.webTabSideNav}
                      className={classNames(
                        "__wab_instance",
                        sty.webTabSideNav
                      )}
                      tabs={
                        <React.Fragment>
                          <ButtonTab
                            className={classNames(
                              "__wab_instance",
                              sty.buttonTab__jsz7M
                            )}
                            color={"dark"}
                            iconTab={
                              <Icon26Icon
                                className={classNames(
                                  projectcss.all,
                                  sty.svg__rrZp1
                                )}
                                role={"img"}
                              />
                            }
                            status={"selected"}
                          />

                          <ButtonTab
                            className={classNames(
                              "__wab_instance",
                              sty.buttonTab__eNgM
                            )}
                            color={"light"}
                            iconTab={
                              <Icon21Icon
                                className={classNames(
                                  projectcss.all,
                                  sty.svg___3Tnti
                                )}
                                role={"img"}
                              />
                            }
                            status={"_default"}
                          />

                          <ButtonTab
                            className={classNames(
                              "__wab_instance",
                              sty.buttonTab__iyHbp
                            )}
                            color={"light"}
                            iconTab={
                              <Icon16Icon
                                className={classNames(
                                  projectcss.all,
                                  sty.svg__ck8Ot
                                )}
                                role={"img"}
                              />
                            }
                            status={"_default"}
                          />
                        </React.Fragment>
                      }
                    />
                  }
                />
              }
              tabDock={
                <WebDock
                  data-plasmic-name={"webDock"}
                  data-plasmic-override={overrides.webDock}
                  className={classNames("__wab_instance", sty.webDock)}
                  modulesWrapper={
                    <React.Fragment>
                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock___7YTfH
                        )}
                        color={"light"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__zoYJh
                            )}
                          >
                            <Icon30Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__gvzev
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebHomepage"] = true
                            ? (() => {
                                const actionArgs = { destination: `/` };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebHomepage"] != null &&
                            typeof $steps["goToWebHomepage"] === "object" &&
                            typeof $steps["goToWebHomepage"].then === "function"
                          ) {
                            $steps["goToWebHomepage"] =
                              await $steps["goToWebHomepage"];
                          }
                        }}
                        status={"_default"}
                      />

                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock___8O2Rs
                        )}
                        color={"light"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__q8Tt
                            )}
                          >
                            <Icon23Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__slUgs
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebRoadmap"] = true
                            ? (() => {
                                const actionArgs = { destination: `/roadmap` };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebRoadmap"] != null &&
                            typeof $steps["goToWebRoadmap"] === "object" &&
                            typeof $steps["goToWebRoadmap"].then === "function"
                          ) {
                            $steps["goToWebRoadmap"] =
                              await $steps["goToWebRoadmap"];
                          }
                        }}
                        status={"_default"}
                      />

                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock__yJOj
                        )}
                        color={"light"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__yy08P
                            )}
                          >
                            <Icon34Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg___0Ts0J
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebTheIndependent"] = true
                            ? (() => {
                                const actionArgs = {
                                  destination: `/the-independent`
                                };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebTheIndependent"] != null &&
                            typeof $steps["goToWebTheIndependent"] ===
                              "object" &&
                            typeof $steps["goToWebTheIndependent"].then ===
                              "function"
                          ) {
                            $steps["goToWebTheIndependent"] =
                              await $steps["goToWebTheIndependent"];
                          }
                        }}
                        status={"_default"}
                      />

                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock__ksKay
                        )}
                        color={"light"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__obkZo
                            )}
                          >
                            <Icon32Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg___0QSgl
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebDemo"] = true
                            ? (() => {
                                const actionArgs = { destination: `/demo` };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebDemo"] != null &&
                            typeof $steps["goToWebDemo"] === "object" &&
                            typeof $steps["goToWebDemo"].then === "function"
                          ) {
                            $steps["goToWebDemo"] = await $steps["goToWebDemo"];
                          }
                        }}
                        status={"_default"}
                      />

                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock__lGvR
                        )}
                        color={"light"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__zxwro
                            )}
                          >
                            <Icon33Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__rnyX2
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebFiles"] = true
                            ? (() => {
                                const actionArgs = { destination: `/files` };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebFiles"] != null &&
                            typeof $steps["goToWebFiles"] === "object" &&
                            typeof $steps["goToWebFiles"].then === "function"
                          ) {
                            $steps["goToWebFiles"] =
                              await $steps["goToWebFiles"];
                          }
                        }}
                        status={"_default"}
                      />

                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock__fB67O
                        )}
                        color={"light"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__r3Ux
                            )}
                          >
                            <Icon15Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__sxdWg
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebSupport"] = true
                            ? (() => {
                                const actionArgs = { destination: `/support` };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebSupport"] != null &&
                            typeof $steps["goToWebSupport"] === "object" &&
                            typeof $steps["goToWebSupport"].then === "function"
                          ) {
                            $steps["goToWebSupport"] =
                              await $steps["goToWebSupport"];
                          }
                        }}
                        status={"_default"}
                      />

                      <div
                        className={classNames(
                          projectcss.all,
                          sty.freeBox__iw1Ku
                        )}
                      >
                        <div
                          className={classNames(
                            projectcss.all,
                            sty.freeBox__enfPn
                          )}
                        />
                      </div>
                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock__tWe5
                        )}
                        color={"dark"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox___8NbKq
                            )}
                          >
                            <Icon27Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__mowCj
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebGallery"] = true
                            ? (() => {
                                const actionArgs = { destination: `/gallery` };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebGallery"] != null &&
                            typeof $steps["goToWebGallery"] === "object" &&
                            typeof $steps["goToWebGallery"].then === "function"
                          ) {
                            $steps["goToWebGallery"] =
                              await $steps["goToWebGallery"];
                          }
                        }}
                        status={"_default"}
                      />

                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock__oz35M
                        )}
                        color={"dark"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__njzvA
                            )}
                          >
                            <Icon26Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__ztb73
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebWorkspace"] = true
                            ? (() => {
                                const actionArgs = {
                                  destination: `/workspace`
                                };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebWorkspace"] != null &&
                            typeof $steps["goToWebWorkspace"] === "object" &&
                            typeof $steps["goToWebWorkspace"].then ===
                              "function"
                          ) {
                            $steps["goToWebWorkspace"] =
                              await $steps["goToWebWorkspace"];
                          }
                        }}
                        status={"selected"}
                      />
                    </React.Fragment>
                  }
                />
              }
              tabNav={
                <WebTopNav
                  data-plasmic-name={"webTopNav"}
                  data-plasmic-override={overrides.webTopNav}
                  className={classNames("__wab_instance", sty.webTopNav)}
                  pageButtons={
                    <React.Fragment>
                      <ButtonSecondary
                        className={classNames(
                          "__wab_instance",
                          sty.buttonSecondary__wmxe8
                        )}
                        color={"tertiary"}
                        content={"join the waitlist"}
                        onClick={async () => {
                          const $steps = {};
                        }}
                      />

                      <ButtonSecondary
                        className={classNames(
                          "__wab_instance",
                          sty.buttonSecondary___7Zna
                        )}
                        color={"primary"}
                        content={"x"}
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebWorkspace"] = true
                            ? (() => {
                                const actionArgs = {
                                  destination: `/workspace`
                                };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebWorkspace"] != null &&
                            typeof $steps["goToWebWorkspace"] === "object" &&
                            typeof $steps["goToWebWorkspace"].then ===
                              "function"
                          ) {
                            $steps["goToWebWorkspace"] =
                              await $steps["goToWebWorkspace"];
                          }
                        }}
                      />
                    </React.Fragment>
                  }
                  pageTitle={
                    <Breadcrumb
                      data-plasmic-name={"breadcrumb"}
                      data-plasmic-override={overrides.breadcrumb}
                      bgColor={"noBackground"}
                      className={classNames("__wab_instance", sty.breadcrumb)}
                      crumb1={"files."}
                      crumb2={"the independent."}
                      crumbCount={"justTitle"}
                      sidePadding={"_default"}
                      size={"navS"}
                      tabTitle={"o21p partners community."}
                    />
                  }
                />
              }
            />
          }
          className={classNames("__wab_instance", sty.appShell)}
          layoutType={"_default"}
        />
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "appShell",
    "webTab",
    "webTopNav",
    "breadcrumb",
    "tabInTab",
    "webTabSideNav",
    "h1",
    "text",
    "separatorVertical",
    "widgetPeopleWall",
    "webDock"
  ],

  appShell: [
    "appShell",
    "webTab",
    "webTopNav",
    "breadcrumb",
    "tabInTab",
    "webTabSideNav",
    "h1",
    "text",
    "separatorVertical",
    "widgetPeopleWall",
    "webDock"
  ],

  webTab: [
    "webTab",
    "webTopNav",
    "breadcrumb",
    "tabInTab",
    "webTabSideNav",
    "h1",
    "text",
    "separatorVertical",
    "widgetPeopleWall",
    "webDock"
  ],

  webTopNav: ["webTopNav", "breadcrumb"],
  breadcrumb: ["breadcrumb"],
  tabInTab: [
    "tabInTab",
    "webTabSideNav",
    "h1",
    "text",
    "separatorVertical",
    "widgetPeopleWall"
  ],

  webTabSideNav: ["webTabSideNav"],
  h1: ["h1"],
  text: ["text"],
  separatorVertical: ["separatorVertical"],
  widgetPeopleWall: ["widgetPeopleWall"],
  webDock: ["webDock"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicWebPartnersCommunity__ArgProps,
          internalVariantPropNames: PlasmicWebPartnersCommunity__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicWebPartnersCommunity__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicWebPartnersCommunity";
  } else {
    func.displayName = `PlasmicWebPartnersCommunity.${nodeName}`;
  }
  return func;
}

function withUsePlasmicAuth(WrappedComponent) {
  const WithUsePlasmicAuthComponent = props => {
    const dataSourceCtx = usePlasmicDataSourceContext() ?? {};
    const { isUserLoading, user, token } = plasmicAuth.usePlasmicAuth({
      appId: "fRuRbcdHVNMtdcnFK96ivt"
    });
    return (
      <PlasmicDataSourceContextProvider__
        value={{
          ...dataSourceCtx,
          isUserLoading,
          userAuthToken: token,
          user
        }}
      >
        <WrappedComponent {...props} />
      </PlasmicDataSourceContextProvider__>
    );
  };
  return WithUsePlasmicAuthComponent;
}

export const PlasmicWebPartnersCommunity = Object.assign(
  // Top-level PlasmicWebPartnersCommunity renders the root element
  withUsePlasmicAuth(makeNodeComponent("root")),
  {
    // Helper components rendering sub-elements
    appShell: makeNodeComponent("appShell"),
    webTab: makeNodeComponent("webTab"),
    webTopNav: makeNodeComponent("webTopNav"),
    breadcrumb: makeNodeComponent("breadcrumb"),
    tabInTab: makeNodeComponent("tabInTab"),
    webTabSideNav: makeNodeComponent("webTabSideNav"),
    h1: makeNodeComponent("h1"),
    text: makeNodeComponent("text"),
    separatorVertical: makeNodeComponent("separatorVertical"),
    widgetPeopleWall: makeNodeComponent("widgetPeopleWall"),
    webDock: makeNodeComponent("webDock"),
    // Metadata about props expected for PlasmicWebPartnersCommunity
    internalVariantProps: PlasmicWebPartnersCommunity__VariantProps,
    internalArgProps: PlasmicWebPartnersCommunity__ArgProps,
    pageMetadata: generateDynamicMetadata(wrapQueriesWithLoadingProxy({}), {
      pageRoute: "/partners-community",
      pagePath: "/partners-community",
      params: {},
      query: {}
    })
  }
);

export default PlasmicWebPartnersCommunity;
/* prettier-ignore-end */
